package app.nestbridge.domain.identity.usecase

import app.nestbridge.domain.identity.model.ProfessionalProfile
import app.nestbridge.domain.identity.service.ProfessionalProfileService
import me.tatarka.inject.annotations.Inject

@Inject
class GetCurrentProfessionalProfileUseCase(
    private val professionalProfileService: ProfessionalProfileService,
) {
    suspend operator fun invoke(): ProfessionalProfile? = professionalProfileService.getCurrent()
}
